<div [class]="containerClass()">
  @if (showHeaderControls()) {
    <div class="header mb-7">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-5 w-full">
          @if (showSearchField()) {
            <div class="w-full">
              <ngx-skeleton-loader [theme]="searchInputTheme" />
            </div>
          }

          @if (showFilters() && filters().length) {
            <div [ngClass]="filterContainerClass()">
              @for (filter of filters(); track filter) {
                <div [ngClass]="filter.containerClass ?? 'w-full'">
                  <ngx-skeleton-loader
                    [ngClass]="filter.inputClass ?? 'w-full'"
                    [theme]="{
                      height: filterInputTheme.height,
                      'border-radius': filterInputTheme['border-radius'],
                      width: '100%',
                    }"
                  />
                </div>
              }
            </div>
          }
        </div>

        @if (showCreateButton()) {
          <ngx-skeleton-loader [theme]="createButtonTheme" />
        }
      </div>
    </div>
  }

  <div class="skeleton-table">
    @if (showColumns()) {
      <div class="skeleton-header flex items-center h-14" [ngStyle]="{ gap: columnGap(), margin: headerMargin() }">
        @for (column of columnsFormatted(); track column) {
          <div [ngClass]="getColumnClass(column)" [ngStyle]="{ padding: headerPadding() }">
            <ngx-skeleton-loader
              [theme]="{
                width: column.width || headerColumnTheme.width,
                height: headerColumnTheme.height,
                'border-radius': headerColumnTheme['border-radius'],
              }"
            />
          </div>
        }
      </div>
    }

    @for (i of rowsArray; track i) {
      <div
        class="flex items-center rounded-full"
        [class.bg-shikenso-gray-base]="hasAlteringRowBackgroundColor() && i % 2 === 0"
        [ngStyle]="{
          padding: columnsFormatted()[0].rowPadding || defaultRowPadding,
          margin: columnsFormatted()[0].rowMargin || defaultRowMargin,
        }"
      >
        @for (column of columnsFormatted(); track column.id) {
          @let col = getCol(column, i);

          <div [ngClass]="getColumnClass(col)" [style.gap]="col.gap">
            @if (col.type === 'icon' && col.hasText) {
              <div
                class="flex items-center"
                [ngStyle]="{ gap: col.gap || '0.5rem', padding: col.columnPadding || defaultColumnPadding }"
              >
                <ngx-skeleton-loader
                  [theme]="{
                    width: col.circleSize || iconTheme.width,
                    height: col.circleSize || iconTheme.height,
                    'border-radius': col.iconRadius || iconTheme['border-radius'],
                  }"
                />
                <ngx-skeleton-loader
                  [theme]="{
                    width: col.textWidth || textWithIconTheme.width,
                    height: col.height || textWithIconTheme.height,
                    'border-radius': col.borderRadius || textWithIconTheme['border-radius'],
                  }"
                />
              </div>
            } @else if (col.type === 'icon') {
              <div
                class="flex items-center"
                [ngStyle]="{ gap: col.gap || '0.5rem', padding: col.columnPadding || defaultColumnPadding }"
              >
                <ngx-skeleton-loader
                  class="w-full"
                  [theme]="{
                    width: col.circleSize || iconOnlyTheme.width,
                    height: col.circleSize || iconOnlyTheme.height,
                    'border-radius': col.borderRadius || iconOnlyTheme['border-radius'],
                  }"
                />
              </div>
            } @else if (col.type === 'text') {
              <div
                class="flex items-center w-full"
                [ngStyle]="{ gap: col.gap || '0.5rem', padding: col.columnPadding || defaultColumnPadding }"
              >
                <ngx-skeleton-loader
                  class="w-full"
                  [theme]="{
                    width: col.textWidth || col.width || textTheme.width,
                    height: col.height || textTheme.height,
                    'border-radius': col.borderRadius || textTheme['border-radius'],
                  }"
                />
              </div>
            }
          </div>
        }
      </div>
    }

    @if (showPaginator()) {
      <div class="skeleton-paginator p-4 flex justify-end items-center gap-4">
        <ngx-skeleton-loader [theme]="paginatorShortTheme" />
        <ngx-skeleton-loader [theme]="paginatorLongTheme" />
      </div>
    }
  </div>
</div>
